import { merge } from '../../helper';

import * as exAlert from '../../components/alert';
import * as exTab from '../../components/tab';

import * as exInput from '../input';
import * as exSelect from '../select';

// ----------------------------------------------------------------------------

export type TypeElements = HTMLElement | HTMLElement[];

export type TypeGeneralConfig = {
    alert?: Record<string, any>;
    input?: Record<string, any>;
    select?: Record<string, any>;
    tab?: Record<string, any>;
};

// ----------------------------------------------------------------------------

function general(elements: TypeElements, config?: TypeGeneralConfig): void {
    alert(elements, config?.alert);
    input(elements, config?.input);
    select(elements, config?.select);
    tab(elements, config?.tab);
}

// ----------------------------------------------------------------------------

function alert(elements: TypeElements, config?: Record<string, any>): void {
    // Default Config
    const defConfig: Record<string, any> = {
        selector: '.alert',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    if (!Array.isArray(elements)) {
        elements = [elements];
    }

    for (const element of elements) {
        const listElements = element.querySelectorAll(defConfig.selector).toArray();

        for (const listElement of listElements) {
            exAlert.close(listElement);
        }
    }
}

function input(elements: TypeElements, config?: Record<string, any>): void {
    // Default Config
    const defConfig: Record<string, any> = {
        selector: 'input, textarea',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    if (!Array.isArray(elements)) {
        elements = [elements];
    }

    for (const element of elements) {
        const listElements = element.querySelectorAll(defConfig.selector).toArray();

        if (listElements.length) {
            exInput.reset.validation(listElements, config);
        }
    }
}

function select(elements: TypeElements, config?: Record<string, any>): void {
    // Default Config
    const defConfig: Record<string, any> = {
        selector: 'select',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    if (!Array.isArray(elements)) {
        elements = [elements];
    }

    for (const element of elements) {
        const listElements = element.querySelectorAll(defConfig.selector).toArray();

        if (listElements.length) {
            exSelect.reset.validation(listElements, config);
        }
    }
}

function tab(elements: TypeElements, config?: Record<string, any>): void {
    // Default Config
    const defConfig: Record<string, any> = {
        selector: '.nav.nav-tabs',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    if (!Array.isArray(elements)) {
        elements = [elements];
    }

    for (const element of elements) {
        const listElements = element.querySelectorAll(defConfig.selector).toArray();

        if (listElements.length) {
            exTab.reset.validation(listElements, config);
        }
    }
}

// ----------------------------------------------------------------------------

export { general, alert, input, select, tab };
